module.exports = __webpack_public_path__ + "img/S1051445.6bbe30be.jpg";